import React from 'react';
import { useJsApiLoader } from '@react-google-maps/api';
import { useTranslation } from 'react-i18next';
import {
  GOOGLE_MAPS_BASE_OPTIONS,
  GOOGLE_MAPS_DEFAULT_LIBRARIES,
} from 'src/config/googleMaps';

export default function LazyLoadScript({
  children,
  libraries = GOOGLE_MAPS_DEFAULT_LIBRARIES,
  loadingElement = null,
  ...other
}) {
  const { t } = useTranslation();
  const { isLoaded, loadError } = useJsApiLoader({
    ...GOOGLE_MAPS_BASE_OPTIONS,
    libraries,
    ...other,
  });

  if (loadError) {
    return <div>{t('maps.error-loading-google-maps')}</div>;
  }

  if (!isLoaded) {
    return loadingElement;
  }

  return children;
}
